module.exports = __webpack_public_path__ + "static/media/truck9.c9585f03.svg";